import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/home/Inicio.js";
import Equipos from "./components/EditarEquipos/Equipos.js";
import Partidos from "./components/NuevaFecha/Partidos.js";
import Turnos from "./components/EditarTurnos/Turnos.js";
import Torneo from "./components/VerTorneo/Torneo.js";
import Fecha from "./components/VerFecha/Fecha.js";
import "bootstrap/dist/css/bootstrap.min.css";

import "../src/assets/css/style.css";
import React, { useEffect, useState } from "react";
import { AppProvider } from "./AppContext";

import { Analytics } from '@vercel/analytics/react';

//Inicio de la pag
import Welcome from "./components/Welcome.js";

// Landing + Login y Register
import LandingPage from "./components/LandingPage/landing.js";
import Login from "./components/LoginRegister/Login.js";
import Register from "./components/LoginRegister/Register.js";
import SignUp from "./components/LoginRegister/SignUp.js";
import ProtectedRoute from "./components/utils/ProtectedRoute.js";
// import LogoutButton from "./components/LogoutButton";

// import { NextUIProvider } from "@nextui-org/react";
// import { Button } from "@nextui-org/button";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    // <NextUIProvider>
    <Router>
      <ToastContainer />
     <Analytics />
      <AppProvider>
        <Routes>
          <Route path="/" element={<Welcome />} />
          {/* <Route path="/home/:idUsuario" element={<Home />} /> */}

          {/*Si no hay token, lo dirigo al welcome*/}
          <Route path="/home" element={<Home />} />
          <Route path="/welcome" element={<LandingPage />} />

          {/* <Route path="/login" element={<Login />} /> */}
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/signup" element={<SignUp />} />

          {/* {idTorneosUsuario.length > 0 && (
            <Route element={<ProtectedRoute turnos={idTorneosUsuario} />}>
              <Route path="/torneo/:idTorneo" element={<Torneo />} />
            </Route>
          )} */}
          <Route element={<ProtectedRoute />}>
            <Route path="/torneo/:idTorneo" element={<Torneo />} />
          </Route>
          {/* <Route path="/torneo/:idTorneo" element={<Torneo />} /> */}
          <Route path="/torneo/:idTorneo/fecha/:idFecha" element={<Fecha />} />
          <Route path="/torneo/:idTorneo/nueva-fecha" element={<Partidos />} />
          <Route path="/torneo/:idTorneo/crear-turnos" element={<Turnos />} />
          <Route
            path="/torneo/:idTorneo/asignar-turnos"
            element={<Equipos />}
          />
          {/* <Route path="/logout" element={<Logout />} /> */}
        </Routes>
      </AppProvider>
    </Router>
    // </NextUIProvider>
  );
}

export default App;
